import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.asset.isValid;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'ASSET_ISVALID',
	method: 'POST',
	url: '/asset/isValid.json',
});

export { actions, reducer, sagas, selectors };
